import { useQuery, useQueryClient } from '@tanstack/react-query';

import { useEffect } from 'react';
import { fetchProjectComments } from '@/api/v4/project-comments.api';
import { QueryKey } from '@/config/query-client';

import { projectIdState } from '../../project.state';
import { useAtomValue } from 'jotai';

export const useProjectComments = () => {
  const queryClient = useQueryClient();
  const projectId = useAtomValue(projectIdState);

  const handleFetchProjectComments = async () => {
    if (!projectId) return [];

    return fetchProjectComments(projectId);
  };

  const query = useQuery({
    queryKey: [QueryKey.ProjectComments, projectId],
    queryFn: handleFetchProjectComments,
    enabled: !!projectId,
    staleTime: 1000 * 60 * 5,
  });

  useEffect(() => {
    if (query.data) {
      void queryClient.invalidateQueries({
        queryKey: [QueryKey.ProjectActionsInfo, projectId],
      });
    }
  }, [query.data, queryClient, projectId]);

  return query;
};
